import { render, staticRenderFns } from "./demandTree.vue?vue&type=template&id=40c9e988&scoped=true&"
import script from "./demandTree.vue?vue&type=script&lang=js&"
export * from "./demandTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9e988",
  null
  
)

export default component.exports